import React from 'react'
import { connect } from 'react-redux'
import { TidewaysContext } from '../app/context'
import { TraceSummarySingleView } from '../domain/TraceSummary'
import { ApplicationState } from '../redux/ApplicationState'
import Router from '../router'

interface OwnProps {
    profile: TraceSummarySingleView
}

interface StateProps {
    router: Router
    tidewaysContext: TidewaysContext
}

type Props = OwnProps & StateProps

class NoCallgraphAttached extends React.Component<Props> {
    public render() {
        return (
            <div className="row">
                <div className="col-lg-8 col-md-12">
                    <div className="box">
                        <div className="box-body">
                            <div className="centered" style={{ marginTop: '50px', marginBottom: '50px' }}>
                                <h4>
                                    <i className="fa fa-ban" /> There is no call data attached to this trace
                                </h4>

                                <p>You can trigger a trace manually that contains function call data.</p>
                            </div>

                            <h4>Trigger using Commandline Client</h4>

                            <p>
                                You can trigger traces for PHP scripts in your application using the{' '}
                                <a
                                    href="https://support.tideways.com/article/59-commandline-interface?utm_medium=app&utm_source=no-callgraph-attached&utm_campaign=commandline"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    commandline client
                                </a>
                                .
                            </p>

                            <h4>Trigger using Chrome Extension</h4>

                            <p>
                                You can trigger traces using the Chrome Extension. After{' '}
                                <a
                                    href="https://support.tideways.com/article/58-chrome-extension?utm_medium=app&utm_source=no-callgraph-attached&utm_campaign=chrome-extension"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    installation
                                </a>
                                , click the Tideways Profiler button in the toolbar to start tracing.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default connect<StateProps, OwnProps>((globalState: ApplicationState, props: OwnProps) => {
    return {
        ...props,
        tidewaysContext: globalState.tidewaysContext,
        router: globalState.tidewaysContext.router,
    }
})(NoCallgraphAttached)
